import { StepperIndexes } from "../../stepperIndexes";
import { StepperState, StepperType } from "../slices/stepperSlice";

export const buildStepperState = (
    allStepsList: StepperIndexes[],
    stepperType: StepperType,
    contractId: string,
    initializationErrorCode?: StepperState["initializationErrorCode"],
    stepIndex: number = 0,
): StepperState => {
    let stepDependentFields: Partial<StepperState> = {};

    if (
        allStepsList.includes(StepperIndexes.editExistingInvestmentStrategyPage) ||
        allStepsList.includes(StepperIndexes.editNewInvestmentStrategyPage)
    ) {
        stepDependentFields.editInvestmentStrategyResult = null;
    }

    if (
        allStepsList.includes(StepperIndexes.smsVerificationPage) ||
        allStepsList.includes(StepperIndexes.phoneNumberPage)
    ) {
        stepDependentFields = {
            ...stepDependentFields,
            smsStepState: {
                phoneNumber: "",
                transactionId: "",
                errorString: "",
            },
            smsVerificationStep: {
                errorString: "",
            },
        };
    }

    return {
        questionnaireRejected: false,
        ...stepDependentFields,
        allStepsList: allStepsList,
        stepIndex: stepIndex,
        stepperType: stepperType,
        contractId,
        initializationErrorCode,
        lastQuestionnaireSubmitDate: { status: "notLoaded" },
    };
};

export const pensionQuestionnaireSteps = [
    // all staps that calls API shoud disable "Next" button until API call is finished (Loading button)!!!
    StepperIndexes.changePensionQuestionnaireIntroPage,
    StepperIndexes.sustainabilityPage,
    StepperIndexes.startPage,
    StepperIndexes.questionnairePage,
    StepperIndexes.investmentProfile,
    StepperIndexes.whatToChange,
    StepperIndexes.editExistingInvestmentStrategyPage, // save to redux, API + TYPES missing
    StepperIndexes.editNewInvestmentStrategyPage, // save to redux, API + TYPES missing
    StepperIndexes.changesOverviewPage,
    StepperIndexes.pdfPage, // download and display actual PDF - 1MD
    StepperIndexes.phoneNumberPage,
    StepperIndexes.smsVerificationPage,
    StepperIndexes.changeRequestPage,
];
export const pensionQuestionnaireInvestmentStrategySteps = [
    // all staps that calls API shoud disable "Next" button until API call is finished (Loading button)!!!
    StepperIndexes.introPage,
    StepperIndexes.sustainabilityPage,
    StepperIndexes.startPage,
    StepperIndexes.questionnairePage,
    StepperIndexes.investmentProfile,
    StepperIndexes.whatToChangeInvestmentStrategy,
    StepperIndexes.editExistingInvestmentStrategyPage, // save to redux, API + TYPES missing
    StepperIndexes.editNewInvestmentStrategyPage, // save to redux, API + TYPES missing
    StepperIndexes.changesOverviewPage,
    StepperIndexes.pdfPage, // download and display actual PDF - 1MD
    StepperIndexes.phoneNumberPage,
    StepperIndexes.smsVerificationPage,
    StepperIndexes.changeRequestPage,
];

export const pensionQuestionnaireStepsWithoutIntro = [
    // For changePensionContribution flow - skips the intro page
    StepperIndexes.sustainabilityPage,
    StepperIndexes.startPage,
    StepperIndexes.questionnairePage,
    StepperIndexes.investmentProfile,
    StepperIndexes.whatToChange,
    StepperIndexes.editExistingInvestmentStrategyPage,
    StepperIndexes.editNewInvestmentStrategyPage,
    StepperIndexes.changesOverviewPage,
    StepperIndexes.pdfPage,
    StepperIndexes.phoneNumberPage,
    StepperIndexes.smsVerificationPage,
    StepperIndexes.changeRequestPage,
];

export const pensionContributionQuestionnaireSteps = [
    // Static steps for changing pension contribution
    // All other steps are conditional based on what user wants to change
    StepperIndexes.changeContributionPage,
    StepperIndexes.changeContributionOverviewPage,
    StepperIndexes.changeContributionRecapPage,
    StepperIndexes.changeContributionRequestSentPage,
];

export const changePensionContributionPrerequisiteSteps = (bankId: boolean | undefined, aml: boolean | undefined) => [
    ...(bankId === true ? [StepperIndexes.bankIdentificationPage] : []),
    ...(aml === true ? [StepperIndexes.amlIdentificationIntroPage, StepperIndexes.amlIdentificationPage] : []),
];
